import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const MichiganStateUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Michigan State University"
      universityShortName="MSU"
      slug="michigan-state-university"
      seoTitle="MSU Study Rooms | Michigan State University Library Study Spaces"
      seoDescription="Find study rooms at MSU including Main Library and Gast Business Library. Learn booking policies and discover CSW as an online alternative."
      seoKeywords="MSU study rooms, Michigan State University library, East Lansing study spaces, Spartan study rooms, MSU Main Library"
      canonicalUrl="/study-room/michigan-state-university/"
      heroDescription="Explore MSU's study room options from the Main Library to specialized branches."
      libraryWebsiteUrl="https://lib.msu.edu"
      libraryWebsiteName="MSU Libraries"
      studySpaces={[
        {
          name: "Main Library - Group Rooms",
          features: "Online reservations, MSU ID required, 15-min check-in, 2 hours/day max.",
          feedback: "Variety of study zones. Fourth floor is quietest."
        },
        {
          name: "Main Library - Fourth Floor",
          features: "Silent study area, individual desks and carrels.",
          feedback: "Best for serious focused work. Enforced quiet zone."
        },
        {
          name: "Gast Business Library",
          features: "Group rooms up to 10 people, media-equipped, online booking.",
          feedback: "Ideal for collaborative work and presentations. Modern facilities."
        },
        {
          name: "Business Library - Quiet Corners",
          features: "Individual study spaces, professional atmosphere.",
          feedback: "Less crowded than Main Library. Good for focused work."
        }
      ]}
      guideContent={
        <>
          <p>
            The Gast Business Library and other MSU libraries require online reservations. Users must show an MSU ID 
            at the circulation desk and check in; reservations are held for 15 minutes, limited to two hours per day.
          </p>
          <p className="mt-4">
            Group rooms seat up to 10 people, and noise, tobacco use and inappropriate behavior are prohibited. 
            Spaces must be left clean. Students note that people sometimes talk loudly in quiet zones.
          </p>
          <p className="mt-4">
            Reserve a group room in advance and check in on time; choose the fourth floor of the Main Library for silence. 
            For collaborative work, the Business Library's media-equipped rooms are ideal. Bring headphones to counter 
            occasional noise spillover.
          </p>
        </>
      }
      summaryTips={[
        "Reservations limited to 2 hours per day",
        "Check in within 15 minutes with MSU ID",
        "Fourth floor of Main Library is the quietest",
        "Business Library has best tech for group work",
        "Leave spaces clean - it's required"
      ]}
    />
  );
};

export default MichiganStateUniversity;
